import { CheckIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

/** The dark half of the subscribe dialog: what a subscription buys. */
export const SubscribeBenefits = () => {
  const { t } = useTranslation()

  return (
    <div className="flex min-w-0 flex-col gap-6 bg-brand-gran p-8 text-white">
      <span className="font-mono text-[11px] font-semibold uppercase tracking-wider text-white">
        {t('subscribeDialog.included.label')}
      </span>

      <ul className="flex flex-col gap-4">
        {(
          [
            'subscribeDialog.included.documents',
            'subscribeDialog.included.conversations',
            'subscribeDialog.included.findSupport',
            'subscribeDialog.included.sharedAccess',
          ] as const
        ).map(key => (
          <li className="flex items-start gap-3" key={key}>
            <CheckIcon className="mt-0.5 size-[18px] shrink-0 text-brand-lime" strokeWidth={3} />
            <span className="text-[15px] leading-snug">{t(key)}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
